import {getImageRatio} from '../../atoms/Image/getImageRatio.function';
import {ThumbnailType} from './ThumbnailType.enum';

type ThumbnailRatioMap = {
  [K in ThumbnailType]: K extends
    | ThumbnailType.OperationDayOfWeekCardBanner
    | ThumbnailType.OperationDayOfWeekCardBannerMobile
    ? string
    : number;
};

export const ThumbnailRatio: ThumbnailRatioMap = {
  // 디자인 팀이랑 논의후 1.43고정으로 하기로 했습니다.
  [ThumbnailType.Portrait]: 1.43,
  [ThumbnailType.Card]: getImageRatio({width: 1, height: 1.8}),
  [ThumbnailType.Square]: 1,
  // https://app.zeplin.io/project/60bf1aa29120fb16ff1b4efc/screen/6114b6711dc1339e65ed277d
  [ThumbnailType.Poster]: 1.43,
  // 콘텐츠홈에서 먼저 도입된 포스터 뷰는 2:3 비율을 사용합니다.
  [ThumbnailType.Poster2To3]: getImageRatio({width: 2, height: 3}),
  // 선물함/기다무플러스 프로모션 작품 운영 영역에서 사용됩니다.
  [ThumbnailType.Promotion]: 1.44,
  //웰컴 페이지 배너에서 사용됩니다.
  [ThumbnailType.Banner]: getImageRatio({width: 18, height: 13}),
  [ThumbnailType.Book]: getImageRatio({width: 2, height: 3}),
  /**
   * 요일연재에서 운영 카드 배너에서 사용됩니다.
   * width : 모바일의 경우 일반 카드 너비, 아닌 경우 일반 카드 2개 너비 +2로 적용 (디바이스에 따라 사이즈 가변)
   * height : 일반 카드 2개 높이 +2로 적용 (디바이스에 따라 사이즈 가변)
   */
  [ThumbnailType.OperationDayOfWeekCardBanner]: 'calc(180% - 1.6px)',
  [ThumbnailType.OperationDayOfWeekCardBannerMobile]: 'calc(360% + 2px)',
};
